import { SalesOrderLineStatusItem } from './sales-order-line-status-item';
import { OrderLineAgent } from './order-line-agent';

export interface SalesOrderLineDetails {
  id: string;
  salesOrderHeaderId: string;
  salesOrderAndLineNo: string;
  salesContractLineId: string;
  salesContractHeaderId: string;
  customerKey: string;
  customerName: string;
  sequence: number;
  productId: string;
  productKey: string;
  productDescription: string;
  productComments: string;
  currencySymbol: string;
  currencyDescriptionOverride: string;
  productTypeId: string;
  productTypeDescription: string;
  unitOfMeasureId: string;
  unitOfMeasureDescription: string;
  customerLineRef: string;
  quantity: number;
  convertedQuantity: number;
  conversionQuantity: number;
  PriceListConversionId: string;
  productPriceListConversionId: string;
  priceListUnitOfMeasureId: string;
  priceListUnitOfMeasureDescription: string;
  orderUnitOfMeasureId: string;
  orderUnitOfMeasureDescription: string;
  price: number;
  noOfItems: number;
  deliveryWeek: number;
  deliveryDate: Date;
  customerNotes: string;
  internalNotes: string;
  noActionRequired: boolean;
  orderBookNotes: string;
  orderLineStatusId: string;
  stockAllocationComplete: boolean;
  warehouseToAllocate: boolean;
  deliveryPeriodId: string;
  deliveryMonthId: string;
  deliveryYear: number;
  callOff: boolean;
  customerClientRef1: string;
  customerClientRef2: string;
  customerClientRef3: string;
  reserved: boolean;
  reservationExpiryDate: Date;
  nextDayDelivery: boolean;
  autoCreatePO: boolean;
  outOfStock: boolean;
  madeToMeasureProduct: boolean;
  poNarrative: string;
  held: boolean;
  exStock: boolean;
  defaultLeadTime: boolean;
  urgent: boolean;
  makeUpId: string;
  deliveryNotes: string;
  priceListQty: number;
  priceOnPriceList: number;
  discountOnFile: number;
  discountRate: number;
  regainCondition: number;
  batchToUse: string;
  commission: number;
  cutPrice: boolean;
  includeSurcharge: boolean;
  allocatedQuantity: number;
  contractDetails: string;
  allocateFullPieces: boolean;
  inlineAllocation: boolean;
  currencyCode: string;
  standardRollLength: number;
  allocateFromWarehouseId: string;
  nearestEighth: boolean;
  bomProduct: string;
  customerDefinedQuantity: number;
  billOfMaterialItems: boolean;
  fabricProcessingFabricId: string;
  allocationType: string;
  customerDescription: string;
  returnableProduct: boolean;
  returnDate: Date;
  confirmed: boolean;

  salesOrderLineStatusItems: SalesOrderLineStatusItem[];
  orderLineAgents: OrderLineAgent[];
}
